import styled from 'styled-components';
import {
  Icon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: ${(props) => props.theme.color.backgroundBanner};
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`;

export const Text = styled(TextLayoutComponent.Secondary)``;

export const Link = styled.a``;

export const IconClose = styled(Icon)`
  &&& {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    width: 25px;
    height: 25px;
  }
`;
